module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("WARFARE AND CULTURE SERIES")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("General Editor: Wayne E. Lee")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("A Rabble in Arms:")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Massachusetts Towns and Militiamen during King Philip’s War")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Kyle F. Zelner")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("Empires and Indigenes: Intercultural Alliance, Imperial Expansion, and Warfare in the Early Modern World")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Edited by Wayne E. Lee")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("Warfare and Culture in World History")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Edited by Wayne E. Lee")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("Rustic Warriors: Warfare and the Provincial Solider on the New England Frontier, 1689–1748")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Steven C. Eames")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("Forging Napoleon’s Grand Armée: Motivation, Military Culture, and Masculinity in the French Army, 1800-1808")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Michael J. Hughes")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("Under the Shadow of Napoleon: French Influence on the American Way of Warfare from the War of 1812 to the Outbreak of WWII")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Michael A. Bonura")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47714b11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02.vue
// module id = 63
// module chunks = 0